export enum UnitFamily {
  CoupleUnbalance = 0,
  Unbalance = 1,
  Mass = 2,
}

export enum UnitTypes {
  Unbalance = 0,
  Mass = 2,
  Length = 3,
  Density = 4,
  Frequency = 5,
}

export enum ConversionTypes {
  Response = 'response',
  Saving = 'saving',
  Settings = 'settings',
}
